import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import featureSectionTitleStyles from './featureSectionTitleStyles';
import useScrollToSection from '../../../../../hooks/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';

export interface IFeatureSectionTitleProps {
  label: string;
  sectionCode?: string;
  disclaimerIndicative?: string;
}
const FeatureSectionTitle: FC<IFeatureSectionTitleProps> = ({ label, sectionCode, disclaimerIndicative }) => {
  const styles = featureSectionTitleStyles();
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <Typography
      component={'h3'}
      variant="sectionTitle"
      className={styles.title}
      data-test={`accordion:toggle:sectionTitle:${label}`}
    >
      {label}
      {disclaimerIndicative && (
        <IndicativeNumber
          dataTest={`${sectionCode}`}
          displayNumber={disclaimerIndicative}
          onClick={scrollToDisclaimer}
          className={styles.indicativeNumber}
        />
      )}
    </Typography>
  );
};

export default FeatureSectionTitle;
